import React, { Component } from 'react'
import { makeId, get, isset } from '../../helpers/default';

/**
 * props
 * - Direct: true/false
 * - DecoratorIn : (value, this) => {}
 * - DecoratorOut : (value, this) => {}
 * - OnChange : (value, this) => {}
 * - DefaultValue : default value
 * - Options: an object
 * - OnChangeBlur: (value, this)=>{} Onchange and value is modified
 */

class InputParent extends Component {

	constructor(props) {
	    super(props);
	    
		let defaultVal = this.props.DefaultValue??''
		if(this.props.DecoratorIn) defaultVal = this.props.DecoratorIn(defaultVal, this)
	    this.state = {
	    	value: defaultVal,
	    }

		this.id = makeId();
		this.oldValue = this.props.DefaultValue??this.props.value??'';
		this.revert = {};
		this.rent = {};
		
	}

	initial(force={}) {
		this.rent = {}
		for(let key in this.props){
			if(key[0] == key[0].toUpperCase() || force[key]){
				this[key] = this.props[key]
			}else{
				if(key == 'value') continue
				this.rent[key] = this.props[key]
			}
		}

		// var {
		// 	value,
		// 	Direct,
		// 	DecoratorIn,
		// 	DecoratorOut,
		// 	OnChange,
		// 	Suggest,
		// 	DefaultValue,
		// 	Options,
		// 	OnChangeBlur,
		// 	...rent
		// } = this.props;

		// this.rent = rent;
	}

	
	setValue(value){
		return new Promise((resolv, reject)=>{
			// Set value for undirect mode
			if(this.DecoratorIn) value = this.DecoratorIn(value, this);
			if(value == null) value = '';
			this.oldValue = value;
			console.log('set oldValue', this.oldValue)
			this.setState({value: value}, ()=>resolv(value));
		})
		
	}
	
	getValue(){
		if(this.props.Direct){
			var value = this.props.value
		}else{
			var value = this.state.value;
		}
		if(this.DecoratorOut) value = this.DecoratorOut(value, this);
		return value;
	}

	showValue(){
		// Value to show on dom
		if(this.props.Direct){
			var val = get(this.props.value, '');
			if(this.DecoratorIn) val = this.DecoratorIn(val, this);
		}else{
			var val = this.state.value;
		}
		return val
	}
	
	revertValue(value){
		// convert value to option key
		if(this.DecoratorOut) value = this.DecoratorOut(value, this);
		if(isset(this.revert[value])) value = this.revert[value];
		return value;
	}

	onBlurHandle(event){
		if(this.props.onBlur) this.props.onBlur(event);
		let val = event.target.value;
		if(this.DecoratorOut) val = this.DecoratorOut(val, this);
		if(val != this.oldValue){
			if(this.props.OnChangeBlur){
				this.oldValue = val;
				this.props.OnChangeBlur(val, this)
			}
		}
	}

	focus(){
		this.input.focus()
	}

	onChangeHandle(event){
		var val = event.target.value;
		if(this.DecoratorOut) val = this.DecoratorOut(val, this);
		if(!this.props.Direct){
			this.setState({'value': event.target.value}, ()=>{
				if(this.props.OnChange) this.props.OnChange(val, this);
				if(this.loadSuggest) this.loadSuggest()
			})
		}else{
			if(this.props.OnChange){
				this.props.OnChange(val, this);
			}
		}
		
	}
	
}

export default InputParent;